import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
  InputAdornment,
  Button,
  Tooltip,
  IconButton
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, apiPut, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import '../Reports/report.less';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import PageHeader from '../common/PageHeader';
import { checkYearEndBonusValidations, cloneDeep, EnhancedTableHead, GenerateAbsoluteURL, getCurrentPayCycleEndDate, getCurrentPayCycleEndDateByDate, getCurrentPayCycleStartDate, getCurrentPayCycleStartDateByDate, orderBy, UpdateColumnWithConfiguration } from '../../utils/helper';
import { getFormattedValues } from '../../utils/formatData';
import { employeeBonusAccrualList } from '../../constants/MockData';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import SaveIcon from '@material-ui/icons/Save';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AssignmentIcon from '@material-ui/icons/Assignment';

export default class EmployeeBonusAccrual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originalDBEmployeeBonusAccrual: [],
      employeeBonusAccrual: [],
      originalEmployeeBonusAccrual: [],
      departmentMasterData: [],
      accountCodeNameMasterData: [],
      marketMasterData: [],
      propertyMasterData: [],
      employeeMasterData: [],
      designationMasterData: [],
      divisionMasterData: [],
      configuration: [],
      order: 'desc',
      orderBy: 'isEditable',
      selectedData: [],
      defaultSelectedData: [],
      openDialog: false,
      confirmationMessage: '',
      showReport: false,
      updateData: {
        preferredName: ''
      },
      isFreezed: false,
      deleteAccrualId: []
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetMasterData();
  }

  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url: API_URL.Report.GetAccountCodeName,
        key: 'accountCodeNameMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Allocation.GetDivisions,
        key: 'divisionMasterData'
      },
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      }
    ])
      .then(({ departmentMasterData, accountCodeNameMasterData, propertyMasterData, designationMasterData, divisionMasterData, marketMasterData }) => {
        this._asyncRequest = null;
        if (departmentMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const selectedData = [];
        selectedData.push({
          key: 'startDate',
          selected: [{ startDate: moment().format(DateFormat) }]
        });

        this.setState({
          defaultSelectedData: selectedData,
          selectedData,
          departmentMasterData: departmentMasterData.data || [],
          accountCodeNameMasterData: accountCodeNameMasterData.data || [],
          propertyMasterData: (propertyMasterData.data || []).filter(x => parseInt(x.legalEntityId) > 0 && parseInt(x.clientId) > 0),
          designationMasterData: designationMasterData.data || [],
          divisionMasterData: divisionMasterData.data || [],
          marketMasterData: marketMasterData.data || []
        }, () => {
          this.GetEmployeeBonusAccrual(this.state.selectedData);
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  GetEmployeeBonusAccrual = (selectedData) => {
    let startDate = null;
    const marketName =
      selectedData.find((x) => x.key === 'marketName') || {};
    let marketId = null;
    if (
      marketName &&
      marketName.selected &&
      marketName.selected.length > 0
    ) {
      marketId = marketName.selected.map(x => x.marketId).join('|');
    }
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    const params = {
      processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      marketId: marketId
    };
    const employeeParam = {
      processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      DepartmentId: 9
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeBonusAccrual,
        key: 'employeeBonusAccrual',
        params
      },
      {
        url: API_URL.Employee.GetEmployeeInformation,
        key: 'employeeMasterData',
        params: employeeParam
      }
    ])
      .then(({ employeeBonusAccrual, employeeMasterData }) => {
        this._asyncRequest = null;
        if (employeeBonusAccrual.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        employeeBonusAccrual.data = (employeeBonusAccrual.data || []).map(x => {
          if (x.isEditable === true) {
            if (x.propertyId <= 0) {
              x.allocationStartDate = moment(getCurrentPayCycleStartDate()).format(DateFormat);
              x.allocationEndDate = moment(getCurrentPayCycleEndDate()).format(DateFormat);
              x.billingStartDate = moment(getCurrentPayCycleStartDate()).format(DateFormat);
              x.billingEndDate = moment(getCurrentPayCycleEndDate()).format(DateFormat);
            }
            x.preferredNameDisabled = true;
          }
          return x;
        });
        this.setState({
          originalDBEmployeeBonusAccrual: orderBy((employeeBonusAccrual.data || []), this.state.orderBy, this.state.order),
          originalEmployeeBonusAccrual: orderBy((employeeBonusAccrual.data || []), this.state.orderBy, this.state.order),
          employeeBonusAccrual: orderBy((employeeBonusAccrual.data || []), this.state.orderBy, this.state.order),
          configuration: employeeBonusAccrual.config || [],
          isFreezed: (employeeBonusAccrual.data || []).find(x => x.isFreezed === true)?.isFreezed || false,
          showReport: true,
          deleteAccrualId: [],
          employeeMasterData: (employeeMasterData.data || []).filter(x => x.employeeBonusEstimationId > 0)
        }, () => {
          const columns = this.getColumns(employeeBonusAccrual.config || [], employeeBonusAccrual.data || []);
          this.onControlChange(this.state.updateData.preferredName, 'preferredName', columns);
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    const recentlyAddedRecords = this.state.employeeBonusAccrual.filter(x => x.isRecentlyAdded === true);
    let employeeBonusAccrual = orderBy(this.state.employeeBonusAccrual, property, isAsc ? 'desc' : 'asc');
    employeeBonusAccrual = employeeBonusAccrual.filter(x => x.isRecentlyAdded !== true);
    if (recentlyAddedRecords !== undefined && (recentlyAddedRecords || []).length > 0) {
      (recentlyAddedRecords || []).forEach(record => {
        employeeBonusAccrual.unshift(record);
      });
    }
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      employeeBonusAccrual
    });
  };

  getColumns = (configuration, employeeBonusAccrual) => {
    let columns = (UpdateColumnWithConfiguration(employeeBonusAccrualList, configuration) || []).filter(x => x.isVisible === true);
    const isFreezed = employeeBonusAccrual?.find(x => x.isFreezed === true)?.isFreezed || false;
    columns = columns.map(x => {
      if (isFreezed === true && x.isEditable === true && (x.dataFormat === 'DecimalPercent' || x.dataFormat === 'MoneyDecimal')) {
        x.type = 'Number';
      }
      return x;
    });
    return columns;
  }

  onControlChange = (value, fieldName, configData) => {
    const { originalEmployeeBonusAccrual, updateData } = this.state;
    let employeeBonusAccrual = cloneDeep(originalEmployeeBonusAccrual);
    updateData[fieldName] = value;
    configData.map(config => {
      if (config.filterConfig && config.filterConfig.controlType === controlType.TextBox && updateData[config.key]) {
        employeeBonusAccrual = employeeBonusAccrual.filter(x => x[config.key]?.toLowerCase().includes(updateData[config.key]?.toLowerCase()?.trim()) === true);
      }
      if (config.filterConfig && config.filterConfig.controlType === controlType.DropDown && updateData[config.key]) {
        employeeBonusAccrual = employeeBonusAccrual.filter(x => x[config.key]?.toLowerCase() === updateData[config.key]?.toLowerCase()?.trim());
      }
      if (config.filterConfig && config.filterConfig.type === 'MultiText' && updateData[config.key] && updateData[config.key]?.length > 0) {
        employeeBonusAccrual = employeeBonusAccrual.filter(x => updateData[config.key]?.find(y => y === x[config.key]));
      }
      return config;
    });
    this.setState({
      employeeBonusAccrual: orderBy(employeeBonusAccrual, this.state.orderBy, this.state.order)
    });
  }

  renderTable = (employeeBonusAccrual, configuration) => {
    const columns = this.getColumns(configuration, employeeBonusAccrual);
    const EditSource = [];
    EditSource.push(
      { key: 'departmentMasterData', data: this.state.departmentMasterData },
      { key: 'accountCodeNameMasterData', data: this.state.accountCodeNameMasterData },
      { key: 'designationMasterData', data: this.state.designationMasterData },
      { key: 'propertyMasterData', data: this.state.propertyMasterData },
      { key: 'divisionMasterData', data: this.state.divisionMasterData },
      { key: 'marketMasterData', data: this.state.marketMasterData },
      { key: 'employeeMasterData', data: this.state.employeeMasterData }
    );
    return (
      <Table className="reportTable" id="rptTable" stickyHeader style={{ tableLayout: 'fixed' }}>
        <EnhancedTableHead
          updateData={this.state.updateData}
          EditSource={EditSource}
          order={this.state.order}
          orderBy={this.state.orderBy}
          columnSequence={[]}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeBonusAccrual.length}
          headCells={columns}
          onFilterChange={this.onControlChange}
        />
        <TableBody>
          {this.renderTableCell(employeeBonusAccrual, columns, [], 0, EditSource)}
        </TableBody>
      </Table>
    );
  };

  isNumberKey = (evt) => {
    if (evt.target.value === '') {
      return true;
    } else {
      const numericInput = new RegExp(
        '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
      ); // '/^[0-9\b]+$/');
      return numericInput.test(evt.target.value);
    }
  }

  formatNumber = (value) => {
    const last = value?.charAt(value?.length - 1);
    if (last === '.' || last === '0' || (/^0*$/.test(value))) { return value; } else { return parseFloat(value); }
  }

  onChangeValues = (value, data, col, dataSource = []) => {
    const { employeeBonusAccrual, originalEmployeeBonusAccrual } = this.state;
    const selectedRowData = cloneDeep(data);

    this.setState({
      employeeBonusAccrual: this.prepareOnChangeData(employeeBonusAccrual, col, value, data, dataSource),
      originalEmployeeBonusAccrual: this.prepareOnChangeData(originalEmployeeBonusAccrual, col, value, selectedRowData, dataSource)
    });
  }

  prepareOnChangeData = (accrualData, col, value, data, dataSource) => {
    const valuePattern = RegExp(
      '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
    );

    accrualData.map(x => {
      if (x.marketId === data.marketId && x.employeeId === data.employeeId && x.propertyId === data.propertyId) {
        if (col.editConfig.type === controlType.TextNumber) {
          x[col.key] = isNaN(value) || !valuePattern.test(value) || value === '' ? '' : this.formatNumber(value);
          x[col.key] = x[col.key] === '' ? col.showDash === true ? '' : 0 : x[col.key];
          x[col.calculatedFieldName] = x[col.key] === '' ? '' : parseFloat(x[col.key]).toFixed(4);
          x[col.calculatedFieldName] = x[col.calculatedFieldName] === '' ? parseFloat(x[col.originalFieldValue]).toFixed(4) : parseFloat(x[col.calculatedFieldName]).toFixed(4);
        } else {
          x[col.key] = value;
        }
        const selectedSourceData = dataSource.find(z => z[col.key] === value);
        if (col.editConfig.dependentField) {
          col.editConfig.dependentField.map(y => {
            x[y] = selectedSourceData ? selectedSourceData[y] : null;
            const dependentCol = (this.getColumns(this.state.configuration, this.state.employeeBonusAccrual) || []).filter(zx => zx.isVisible === true).find(zx => zx.key === y);
            if (dependentCol !== undefined) {
              x = (checkYearEndBonusValidations(dependentCol, x, x[y]) || {}).x;
            }
            return y;
          });
        }
        if (col?.editConfig?.clearField) {
          col?.editConfig?.clearField?.map(c => {
            x[c] = null;
            return c;
          });
        }
        if (col?.editConfig?.useFormula) {
          const amount = parseFloat(x[col?.editConfig?.calculatedFrom]) * (parseFloat(x[col?.editConfig?.multiplyPercent]) / 100);
          if (col?.editConfig?.calculatedFieldName) {
            col?.editConfig?.calculatedFieldName.map(z => {
              x[z] = amount;
              return z;
            });
          }
          if (col?.editConfig?.calculatedWhen && (x[col?.editConfig?.calculatedWhen?.dependentData?.key] || '') === (col?.editConfig?.calculatedWhen?.dependentData?.value || '')) {
            x[col?.editConfig?.calculatedWhen?.key] = amount;
          }
        }
        x = (checkYearEndBonusValidations(col, x, value) || {}).x;
      }

      return x;
    });
    return accrualData;
  }

  renderControl = (d, col, dataSource = []) => {
    const format = col.editConfig.type;
    const dropdownData = (dataSource.find(x => x.key === col.editConfig.sourceKey)?.data?.filter(
      x => (col.filterBy === undefined || x[col.filterBy] === d[col.filterBy]) &&
        (x[col.editConfig.updateKey] === d[col.editConfig.updateKey] ||
          this.state.originalEmployeeBonusAccrual.find(z =>
            z[col.editConfig.cascaded] === d[col.editConfig.cascaded] &&
            z[col.editConfig.cascaded1] === d[col.editConfig.cascaded1] &&
            z[col.editConfig.updateKey] === x[col.editConfig.updateKey]) === undefined)
    ) || []);
    switch ((format || '').trim()) {
      case controlType.TextNumber:
        return <TextField
          value={d[col.key]}
          error={d[col.key + 'IsInErrorState']}
          helperText={d[col.key + 'ErrorMessage']}
          margin="normal"
          size="small"
          color="primary"
          type='Number'
          className="editable amount-text"
          onChange={(e) => this.isNumberKey(e) ? this.onChangeValues(e.target.value, d, col) : ''}
          InputProps={col.appendText === 'percent'
            ? {
              endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>%</span></InputAdornment>
            }
            : {
              startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment>
            }}
        />;
      case controlType.TextBox:
        return <TextField
          value={d[col.key]}
          margin="normal"
          size="small"
          color="primary"
          type='text'
          className="editable amount-text"
          onChange={(e) => this.onChangeValues(e.target.value, d, col)}
        />;
      case controlType.DropDown:
        return (<>
          <Autocomplete
            size="small"
            error={d[col.key + 'IsInErrorState']}
            helperText={d[col.key + 'ErrorMessage']}
            options={dropdownData.map(
              (option) => option[col.editConfig.sourceOption]
            )}
            value={d[col.key]}
            className="editable"
            key={'dropDown_filter' + col.editConfig.updateKey}
            id={'dropDown_filter' + col.editConfig.updateKey}
            onChange={(event, value) => {
              this.onChangeValues(value, d, col, dropdownData);
            }}
            autoHighlight
            renderInput={(params) => (
              <TextField
                disabled={col.isEditable}
                error={d[col.key + 'IsInErrorState']}
                helperText={d[col.key + 'ErrorMessage']}
                {...params}
                margin="normal"
                className="table-text"
              />
            )}
          />
        </>
        );
    }
  }

  renderActionColumn = (d) => {
    return (<>{
      <Tooltip title="Delete Record">
        <IconButton
          aria-label={'refreshData'}
          size="small"
          onClick={() => {
            this.deleteRecord(d);
          }}
        >
          <DeleteIcon fontSize="small" size="small" />
        </IconButton>
      </Tooltip>
    }</>);
  }

  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0, EditSource = []) => {
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + d.EmployeeBonusAccrualId + '_' + d.allocationId + '_' + d.marketId + '_' + d.propertyId + '_' + d.employeeBonusEstimationId + '_' + d.employeeId + '_' + d.departmentId + '_' + d.expenseAccountId + '_' + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  <TableCell key={key + index} width={col.width || ''} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} >
                    {col.isEditable === true && d.isFreezed !== true && col.editConfig !== undefined && col.editConfig.renderAlways === true
                      ? this.renderControl(d, col, EditSource)
                      : col.editConfig !== undefined && col.isEditable === true && d.isEditable === true && d.isFreezed === false && d[col.key + 'Disabled'] !== true
                        ? this.renderControl(d, col, EditSource)
                        : col.renderComponent !== undefined && d.isFreezed === false && d.isEditable === true
                          ? this.renderActionColumn(d)
                          : col.showDash === true && (d[col.key] === '' || d[col.key] === null) ? <span className="number-text">-</span> : getFormattedValues(d[col.key], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')

                    }

                  </TableCell>
                </>
              );
            })
          }
        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={13} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  deleteRecord = (d) => {
    let { deleteAccrualId, originalEmployeeBonusAccrual, employeeBonusAccrual } = this.state;
    if (d.employeeBonusAccrualId <= 0) {
      // originalEmployeeBonusAccrual = originalEmployeeBonusAccrual.filter(x => x.marketId !== d.marketId && x.employeeId !== d.employeeId && x.propertyId !== d.propertyId && x.isEditable === true);
      // employeeBonusAccrual = employeeBonusAccrual.filter(x => x.marketId !== d.marketId && x.employeeId !== d.employeeId && x.propertyId !== d.propertyId);

      const originalEmployeeBonusAccrual1 = originalEmployeeBonusAccrual.filter(x => x.employeeId !== d.employeeId);
      const originalEmployeeBonusAccrual2 = originalEmployeeBonusAccrual.filter(x => x.employeeId === d.employeeId).filter(y => y.propertyId !== d.propertyId);
      originalEmployeeBonusAccrual = [...originalEmployeeBonusAccrual1, ...originalEmployeeBonusAccrual2];

      const employeeBonusAccrual1 = employeeBonusAccrual.filter(x => x.employeeId !== d.employeeId);
      const employeeBonusAccrual2 = employeeBonusAccrual.filter(x => x.employeeId === d.employeeId).filter(y => y.propertyId !== d.propertyId);
      employeeBonusAccrual = [...employeeBonusAccrual1, ...employeeBonusAccrual2];
    } else {
      deleteAccrualId.push(d.employeeBonusAccrualId);
      originalEmployeeBonusAccrual = originalEmployeeBonusAccrual.filter(x => x.employeeBonusAccrualId !== d.employeeBonusAccrualId);
      employeeBonusAccrual = employeeBonusAccrual.filter(x => x.employeeBonusAccrualId !== d.employeeBonusAccrualId);
    }
    this.setState({
      deleteAccrualId,
      originalEmployeeBonusAccrual,
      employeeBonusAccrual
    });
  }

  onFilterChange = (selectedData) => {
    if (selectedData.find((x) => x.key === 'startDate') === undefined ||
      selectedData.find((x) => x.key === 'startDate').selected === undefined ||
      selectedData.find((x) => x.key === 'startDate').selected <= 0 || (
        selectedData.find((x) => x.key === 'startDate').selected?.length === 1 &&
        selectedData.find((x) => x.key === 'startDate').selected[0]?.startDate === 'Invalid date'
      )) {
      selectedData = selectedData.filter((x) => x.key !== 'startDate');
      selectedData.push({
        key: 'startDate',
        selected: [{ startDate: moment().format(DateFormat) }]
      });
    }
    this.setState({
      selectedData
    }, () => {
      this.GetEmployeeBonusAccrual(selectedData);
    });
  }

  onSubmitClick = () => {
    const formData = this.isValidForm(this.state.originalEmployeeBonusAccrual, this.state.employeeBonusAccrual);
    if (formData !== '' && formData.isValid === false) {
      const originalEmployeeBonusAccrual = orderBy(formData.originalEmployeeBonusAccrual, 'isEditable', 'desc');
      let employeeBonusAccrual = orderBy(formData.employeeBonusAccrual, 'isEditable', 'desc');
      const recentlyAddedRecords = employeeBonusAccrual?.filter(x => x.isRecentlyAdded === true);
      employeeBonusAccrual = employeeBonusAccrual?.filter(x => x.isRecentlyAdded !== true);
      if (recentlyAddedRecords !== undefined && (recentlyAddedRecords || []).length > 0) {
        (recentlyAddedRecords || []).forEach(record => {
          employeeBonusAccrual.unshift(record);
        });
      }
      this.setState({
        employeeBonusAccrual: employeeBonusAccrual,
        originalEmployeeBonusAccrual: originalEmployeeBonusAccrual,
        orderBy: 'isEditable',
        order: 'desc'
      });
    } else {
      this.setState({
        openDialog: true,
        confirmationMessage: 'Do you want to save Yearly Bonus Accrual?'
      });
    }
  }

  onConfirmClickHandle = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
        confirmationMessage: ''
      }, () => {
        this.UpdateEmployeeBonusAccrual();
      });
    } else {
      this.setState({
        openDialog: false,
        confirmationMessage: ''
      });
    }
  }

  UpdateEmployeeBonusAccrual = () => {
    const { selectedData } = this.state;
    let startDate = null;
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    apiPut(
      API_URL.Employee.UpdateEmployeeBonusAccrual,
      this.state.originalEmployeeBonusAccrual,
      {
        deleteAccrualId: this.state.deleteAccrualId.join('|'),
        processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year()
      }).then(({ data: response }) => {
        if (response.success) {
          ShowToast('Yearly Bonus Accrual updated successfully', toastType.SUCCESS, 5000, 500);
          this.GetEmployeeBonusAccrual(this.state.selectedData);
        } else {
          ShowToast(response.message, toastType.ERROR, 5000, 500);
        }
      });
  }

  prepareDataForFinalSave = (data) => {
    let formData = null;
    let isValid = true;
    data.map(x => {
      let rowInvalid = true;
      employeeBonusAccrualList.map(z => {
        formData = checkYearEndBonusValidations(z, x, x[z.key]);
        x = formData.x;
        if (isValid === true) {
          isValid = formData.isValid;
        }
        if (rowInvalid === true) {
          rowInvalid = formData.isValid;
        }
        return z;
      });
      x.isRecentlyAdded = !rowInvalid;
      return x;
    });
    return { data, isValid };
  }

  isValidForm = (originalEmployeeBonusAccrual, employeeBonusAccrual) => {
    let formData = null;
    formData = this.prepareDataForFinalSave(originalEmployeeBonusAccrual);
    employeeBonusAccrual = (this.prepareDataForFinalSave(employeeBonusAccrual) || {}).data;

    if (formData.isValid === false) {
      ShowToast('Please enter valid data in field(s).', toastType.ERROR, 5000, 500);
    }

    return { isValid: formData.isValid, employeeBonusAccrual, originalEmployeeBonusAccrual: formData.data };
  }

  AddPropertyAgainstEmployeeForYearEndBonus = () => {
    const { originalEmployeeBonusAccrual, employeeBonusAccrual, selectedData } = this.state;
    const formData = this.isValidForm(originalEmployeeBonusAccrual, employeeBonusAccrual);
    if (formData.isValid === false) {
      this.setState({
        employeeBonusAccrual: formData.employeeBonusAccrual,
        originalEmployeeBonusAccrual: formData.originalEmployeeBonusAccrual
      });
    } else {
      let startDate = null;
      const startDateData =
        selectedData.find((x) => x.key === 'startDate') || {};

      if (
        startDateData &&
        startDateData.selected &&
        startDateData.selected.length > 0
      ) {
        startDate = moment(startDateData.selected[0].startDate).format(DateFormat);
      } else {
        startDate = moment().format(DateFormat);
      }
      const addNew = {
        isEditable: true,
        accrueBillAmount: 0,
        allocatedBonusAndBurdenRateAmount: 0,
        allocationId: 0,
        allocationPercent: 0,
        billingPercent: 0,
        bonusAmount: 0,
        bonusPercent: 0,
        burdenRatePercent: 0,
        currentAnnualCompensation: 0,
        capOrOtherAmount: null,
        departmentId: 0,
        departmentName: '',
        designation: '',
        designationId: 0,
        division: null,
        divisionId: 0,
        employeeBonusAccrualId: 0,
        employeeBonusEstimationId: 0,
        employeeId: 0,
        expenseAccount: null,
        expenseAccountId: 0,
        isFreezed: false,
        isOverride: false,
        preferredName: null,
        statusId: 1,
        totalBonusAndBurdenRateAmount: 0,
        processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
        propertyId: 0,
        propertyName: null,
        legalEntityId: 0,
        isReimbursed: true,
        allocationStartDate: moment(getCurrentPayCycleStartDateByDate(startDate)).format(DateFormat),
        allocationEndDate: moment(getCurrentPayCycleEndDateByDate(startDate)).format(DateFormat),
        billingStartDate: moment(getCurrentPayCycleStartDateByDate(startDate)).format(DateFormat),
        billingEndDate: moment(getCurrentPayCycleEndDateByDate(startDate)).format(DateFormat),
        isRecentlyAdded: true
      };
      formData.originalEmployeeBonusAccrual.unshift(addNew);
      formData.employeeBonusAccrual.unshift(addNew);
      this.setState({
        originalEmployeeBonusAccrual: formData.originalEmployeeBonusAccrual,
        employeeBonusAccrual: formData.employeeBonusAccrual,
        isValid: false
      });
    }
  }

  downloadFile = (fileMimeType, type, isPrint = false) => {
    const { selectedData } = this.state;
    let startDate = null;
    const marketName =
      selectedData.find((x) => x.key === 'marketName') || {};
    let marketId = null;
    if (
      marketName &&
      marketName.selected &&
      marketName.selected.length > 0
    ) {
      marketId = marketName.selected.map(x => x.marketId).join('|');
    }
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    const dataValue = [
      {
        key: 'ProcessYear',
        value: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year()
      },
      {
        key: 'MarketId',
        value: marketId === null || marketId?.length <= 0 ? '0' : marketId
      }
    ];
    const url = GenerateAbsoluteURL(dataValue, [], 'EmployeeYearlyBonusAccrual', type, false, true);

    downloadReport(
      url,
      'Employee Yearly Bonus Accrual Report',
      fileMimeType,
      type,
      isPrint
    );
  }

  render() {
    const {
      employeeBonusAccrual,
      configuration,
      selectedData,
      defaultSelectedData,
      showReport,
      isFreezed,
      employeeMasterData,
      marketMasterData
    } = this.state;

    const filterConfig = [
      {
        type: controlType.Year,
        key: 'startDate',
        placeholder: 'Search Year',
        title: 'Year',
        clearable: false,
        dontFilterOtherSource: true
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: marketMasterData,
        key: 'marketName',
        placeholder: 'Search Market',
        title: 'Market'
      }
    ];
    return (
      <div>
        {(
          <>
            <ConfirmDialog
              IsOpen={this.state.openDialog}
              Message={this.state.confirmationMessage}
              OnHandelClick={(isValid) => {
                if (isValid) {
                  this.onConfirmClickHandle(isValid);
                } else {
                  this.onConfirmClickHandle(isValid);
                }
              }}
              AgreeText="Yes"
              DisAgreeText="No"
            />
            <PageHeader title="Yearly Bonus Accrual"></PageHeader>
            <PageFilter
              autoFilter={false}
              hidePanel={true}
              filterAlwaysVisible={true}
              onFilterChanged={this.onFilterChange}
              filterConfig={filterConfig}
              defaultSelectedData={defaultSelectedData}
              selectedData={selectedData}
              gridColumn={3}
            />
            {showReport === false &&
              (employeeBonusAccrual == null ||
                employeeBonusAccrual.length <= 0) && (
                <Grid container spacing={4}>
                  <Grid
                    container
                    direction="row-reverse"
                    justify="center"
                    alignItems="stretch"
                  >
                    <label className="item-big">No Data Available.</label>
                  </Grid>
                </Grid>
              )}
            {(
              <div>
                {showReport === true && (
                  <>
                    <div className="col-xs-12 col-lg-12 filter-action-group">
                      <div className="row start-xs end-xs">
                        <div className="col-xs-8 col-sm-8 no-padding">
                          {showReport === true && isFreezed === false && employeeMasterData?.length > 0 && <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => { this.AddPropertyAgainstEmployeeForYearEndBonus(); }}
                          >
                            Add Employee Property Accrual
                                </Button>} &nbsp;&nbsp;
                                {employeeBonusAccrual !== null && isFreezed === false && employeeBonusAccrual?.length > 0 &&
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                onClick={this.onSubmitClick}
                              >
                                Save Yearly Bonus Accrual
                                  </Button>
                            </>}
                                &nbsp;&nbsp;
                                {this.state.originalDBEmployeeBonusAccrual?.length > 0 && <Tooltip title="Export Excel">
                            <IconButton
                              size="small"
                              onClick={() => this.downloadFile('application/vnd.ms-excel', 'Excel')}>
                              <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                                <AssignmentIcon />
                              </div>
                            </IconButton>
                          </Tooltip>}
                        </div>
                      </div>
                    </div>
                    <div className="container year-end-bonus" style={{ marginTop: '1rem' }}>
                      {this.renderTable(employeeBonusAccrual, configuration)}
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
